import script from "./AuthPageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthPageLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthPageLayout.vue?vue&type=style&index=0&id=d8fad9b6&lang=scss&scoped=true"
import "./AuthPageLayout.vue?vue&type=style&index=1&id=d8fad9b6&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8fad9b6"]])

export default __exports__